import { Alert, Autocomplete, Avatar, Backdrop, Button, Chip, CircularProgress, Divider, Fab, FormControlLabel, Grid, InputAdornment, LinearProgress, Paper, Step, StepLabel, Stepper, Switch, Table, TableBody, TableCell, TableContainer, TableRow, TextField, useMediaQuery } from "@mui/material";
import MenuFrame from "../frames/menu_frame";
import { country } from "./country";
import { useState } from "react";
import { adjustFuelField, adjustGstField, adjustSubTotalField, adjustTotalField, calcAmountField, dayBooking, getCnSuggestion, getPinCodeJsr, set_cn_number, validCn, validIndianPin, validMethod, validPercentage, validPrice, validPriceNeg, validWeight } from "./booking_halper";
import { blue } from "@mui/material/colors";
import { dateUsaToTimestamp, getCurrentDate } from "../frames/common";
import { CancelTwoTone, ExpandLess, ExpandMore, QrCode2TwoTone } from "@mui/icons-material";
import QrScanner from "../qr_scanner";
import { CN_METHOD, CN_TYPES } from "../authorization/const";
import { useLanguage } from "../LanguageContext";

const cu_date = getCurrentDate();
const stepError = [false, false, false, false];

function DeskBooking() {
    const { text } = useLanguage();
    const steps = [text("consignment_details"), text("address_details"), text("billing")];
    const [activeTab, setActiveTab] = useState(1);
    const [weightLabel, setWeightLabel] = useState(text("weight_grm"));
    const [inputErrors, setInputErrors] = useState({});
    const [billBreakout, setBillBreakout] = useState({});
    const [cnList, setCnList] = useState(null);
    const [isFuel, setIsFuel] = useState(false);
    const [isGst, setIsGst] = useState(false);
    const [isMisc, setIsMisc] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [openQrCode, setOpenQrCode] = useState(false);
    const [cnAuto, setCnAuto] = useState(true);
    const isXs = useMediaQuery('(max-width:600px)');

    const initData = async (auth) => {
        if (!auth) return;
        setCnList(await getCnSuggestion());
    }

    const __error_handler_tab = (test, tab, vr, msg) => {
        stepError[tab] = !test;
        __error_handler(test, vr, msg);
        return !test;
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const date = dateUsaToTimestamp(data.get("date"));
        const cn_no = data.get("cn_no");
        const weight = Number(data.get("weight"));
        const doc_type = data.get("doc_type");
        const method = data.get("method");
        const pincode = data.get("pincode");
        const destination = data.get("destination");
        const country = data.get("country");
        const address = data.get("address");
        const amount = Number(data.get("amount"));
        const pickup = Number(data.get("pickup"));
        const packaging = Number(data.get("packaging"));
        const other = Number(data.get("other"));
        const insurance = Number(data.get("insurance"));
        const total = Number(data.get("total"));
        const fuel = Number(data.get("fuel"));
        const gst = Number(data.get("gst"));

        var flag = true;
        if (__error_handler_tab(validCn(cn_no), 0, "cn_no", text("incorrect_consignment_number"))) {
            flag = false;
        }
        if (__error_handler_tab(validWeight(weight), 0, "weight", text("weight_must_be_in_grm"))) {
            flag = false;
        }
        if (__error_handler_tab(validMethod(cn_no, method), 0, "method", method + " method not allowed for this CN.")) {
            flag = false;
        }
        if (country === "India" && __error_handler_tab(validIndianPin(pincode), 1, "pincode", text("please_fill_a_valid_pincode"))) {
            flag = false;
        }
        if (__error_handler_tab(validPrice(amount), 2, "amount", text("please_fill_a_valid_amount"))) {
            flag = false;
        }
        if (__error_handler_tab(validPrice(pickup), 2, "pickup", text("please_fill_a_valid_amount"))) {
            flag = false;
        }
        if (__error_handler_tab(validPrice(packaging), 2, "packaging", text("please_fill_a_valid_amount"))) {
            flag = false;
        }
        if (__error_handler_tab(validPriceNeg(other), 2, "other", text("please_fill_a_valid_price"))) {
            flag = false;
        }
        if (__error_handler_tab(validPrice(fuel), 2, "fuel", text("please_fill_a_fuel_charge"))) {
            flag = false;
        }
        if (__error_handler_tab(validPrice(insurance), 2, "insurance", text("please_fill_a_valid_price"))) {
            flag = false;
        }
        if (__error_handler_tab(validPrice(gst), 2, "gst", text("please_fill_a_valid_price"))) {
            flag = false;
        }
        if (__error_handler_tab(validPrice(total), 2, "total", text("please_fill_a_valid_price"))) {
            flag = false;
        }
        if (__error_handler_tab(total >= 0, 2, "total", text("billing_amount_must_be_greater_than_0"))) {
            flag = false;
        }

        if (flag) {
            const _json = {
                "cn": cn_no, "time": date, "destination": destination, "address": address, "country": country,
                "pincode": pincode, "weight": weight, "type": doc_type, "method": method, "amount": amount,
                "fuel": fuel, "pickup": pickup, "packaging": packaging, "insurance": insurance, "other": other,
                "gst": gst, "total": total
            };
            dayBooking(_json).then((_) => {
                setAlertMessage({ severity: "success", message: text("the_consignment_is_booked_succefully") });
                setActiveTab(1);
                setCnList(cnList.filter((itm) => itm !== cn_no));
                event.target.reset();
                setIsLoading(false);
            }).catch((err) => {
                setAlertMessage({ severity: "error", message: err['message'] });
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    const validateInputs = (_) => {
        setIsLoading(true);
        return true;
    }

    const nextPage = (_) => setActiveTab(activeTab + 1);
    const backPage = (_) => setActiveTab(activeTab - 1);

    const handleCnChange = (event) => {
        const cn = event.target.value.toUpperCase();
        __error_handler(validCn(cn), "cn_no", text("incorrect_consignment_number"));
    }

    const handleWeightChange = (event) => {
        const weight = event.target.value;
        setWeightLabel("Weight (Grm) = " + (weight / 1000).toFixed(3) + "kg");
        __error_handler(validWeight(weight), "weight", text("weight_must_be_in_grm"));
    }

    const handlePincodeChange = (event) => {
        const pincode = event.target.value;
        const valid = validIndianPin(pincode);
        __error_handler(valid, "pincode", text("indian_pincode_must_have_6_digit"));
        if (valid) {
            getPinCodeJsr(pincode).then((res) => {
                // console.log(res);
            }).catch((err) => {
                console.error(err);
            });
        };
    }

    const handleAmountChange = (event) => {
        const amt = event.target.value;
        __error_handler(validPrice(amt), "amount", text("please_fill_a_valid_amount"));
        if (validPrice(amt)) setBillBreakout(calcAmountField());
    }

    const handlePickupChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "pickup", text("please_fill_a_valid_amount"));
        if (validPrice(price)) setBillBreakout(calcAmountField());
    }


    const handlePackagingChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "packaging", text("please_fill_a_valid_amount"));
        if (validPrice(price)) setBillBreakout(calcAmountField());
    }


    const handleOtherChange = (event) => {
        const price = event.target.value;
        __error_handler(validPriceNeg(price), "other", text("please_fill_a_valid_price"));
        if (validPriceNeg(price)) setBillBreakout(calcAmountField());
    }

    const handleFuelChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "fuel", text("please_fill_a_fuel_charge"));
        if (validPrice(price)) setBillBreakout(adjustFuelField());
    }

    const handleInsuranceChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "insurance", text("please_fill_a_valid_price"));
        if (validPrice(price)) setBillBreakout(calcAmountField());
    }

    const handleGSTChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "gst", text("please_fill_a_valid_price"));
        if (validPrice(price)) setBillBreakout(adjustGstField());
    }

    const handleSubTotalChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "subtotal", text("please_fill_a_valid_price"));
        if (validPrice(price)) setBillBreakout(adjustSubTotalField());
    }

    const handleTotalChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "total", text("please_fill_a_valid_price"));
        if (validPrice(price)) setBillBreakout(adjustTotalField());
    }

    const handleFuelrateChange = (event) => {
        const per = event.target.value;
        __error_handler(validPercentage(per), "fuel_rate", text("please_enter_fuel_rate_maximum_35"));
        if (validPercentage(per)) setBillBreakout(calcAmountField());
    }

    const handleGstRateChange = (event) => {
        const per = event.target.value;
        __error_handler(validPercentage(per), "gst_rate", text("please_enter_gst_rate_maximum_28"));
        if (validPercentage(per)) setBillBreakout(calcAmountField());
    }

    const handleIsGstChange = (event) => {
        setIsGst(event.target.checked);
        setBillBreakout(calcAmountField());
    }

    const handleIsFuelChange = (event) => {
        setIsFuel(event.target.checked);
        setBillBreakout(calcAmountField());
    }
    const openQrCodeScanner = () => {
        setOpenQrCode(true);
        setCnAuto(false);
    }

    const qrCodeScanned = (val) => {
        // console.log(val);
        setOpenQrCode(false);
        setCnList([val, ...cnList])
        set_cn_number(val);
    }

    const closeQrCodeScanner = (event) => {
        setOpenQrCode(false);
    }

    return (
        <MenuFrame permission="BOOKING_DESK" onInit={initData} screen="DESK_BOOKING">
            {cnList === null || cnList.length === 0 ? <LinearProgress color="primary" /> : ""}
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <QrScanner onClose={closeQrCodeScanner} onScan={qrCodeScanned} scan={openQrCode} />
            <Grid container spacing={2} sx={{ p: 2 }}>
                {alertMessage === null ? "" :
                    <Grid size={12}>
                        <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                    </Grid>
                }
                <Grid size={{ xs: 12, sm: 2 }}>
                    <Stepper activeStep={activeTab - 1} alternativeLabel={isXs ? true : false} orientation={isXs ? 'horizontal' : 'vertical'}>
                        {steps.map((label, idx) => (
                            <Step key={label} onClick={() => { stepError[idx] = false; setActiveTab(idx + 1) }}>
                                <StepLabel error={stepError[idx]} optional={idx === 4}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Grid>
                <Grid size={{ xs: 12, sm: 10 }} component="form" onSubmit={handleSubmit} noValidate>
                    <Grid container spacing={2} component={Paper} sx={{p: 2 }}>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 1 ? "" : "none" }}>
                            <TextField variant="outlined" name="date" type="date" fullWidth error={inputErrors.date} defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2024-04-01" } }} helperText={inputErrors.date} placeholder={text("date")} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 1 ? "" : "none" }}>
                            {cnAuto ?
                                <Autocomplete
                                    freeSolo
                                    disablePortal
                                    options={cnList === null ? [] : cnList}
                                    onBlur={handleCnChange}
                                    defaultValue={""}
                                    renderInput={(params) => <TextField {...params} variant="outlined" name="cn_no" fullWidth error={inputErrors.cn_no} type="text" helperText={inputErrors.cn_no} autoFocus placeholder={text("consignment_number")} label={text("cn_number")} />}
                                />
                                :
                                <TextField variant="outlined" name="cn_no" fullWidth
                                    slotProps={{
                                        input: {
                                            readOnly: true, endAdornment: (
                                                <InputAdornment position="end" onClick={() => setCnAuto(true)} style={{ cursor: "pointer" }}>
                                                    <CancelTwoTone color="warning" />
                                                </InputAdornment>
                                            )
                                        },
                                    }}
                                    error={inputErrors.cn_no} type="text" helperText={inputErrors.cn_no} placeholder={text("consignment_number")} label={text("cn_number")} />
                            }
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 1 ? "" : "none" }}>
                            <TextField variant="outlined" name="weight" fullWidth error={inputErrors.weight} type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 10000000 } }} helperText={inputErrors.weight} placeholder={text("weight_in_grams")} label={weightLabel} onKeyUp={handleWeightChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 1 ? "" : "none" }}>
                            <Autocomplete
                                disablePortal
                                options={CN_TYPES}
                                defaultValue={"Document"}
                                renderInput={(params) => <TextField {...params} variant="outlined" name="doc_type" fullWidth error={inputErrors.doc_type} type="text" helperText={inputErrors.doc_type} placeholder={text("type")} label={text("type")} />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 1 ? "" : "none" }}>
                            <Autocomplete
                                disablePortal
                                options={CN_METHOD}
                                defaultValue={"Express"}
                                renderInput={(params) => <TextField {...params} variant="outlined" name="method" fullWidth error={inputErrors.method} type="text" helperText={inputErrors.method} placeholder={text("method")} label={text("method")} />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 1 ? "" : "none" }} className={"align_text"}>
                            <Fab color="primary" aria-label={text("scan_qr_code")} size="small" onClick={openQrCodeScanner}>
                                <QrCode2TwoTone />
                            </Fab>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 2 ? "" : "none" }}>
                            <TextField variant="outlined" name="pincode" fullWidth autoFocus error={inputErrors.pincode} type="text" helperText={inputErrors.pincode} placeholder={text("pincode")} label={text("pincode")} onChange={handlePincodeChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 2 ? "" : "none" }}>
                            <TextField variant="outlined" name="destination" fullWidth error={inputErrors.destination} type="text" helperText={inputErrors.destination} placeholder={text("destination")} label={text("destination")} />
                        </Grid>
                        {/* <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 2 ? "" : "none" }}>
                            <TextField variant="outlined" name="phone" fullWidth error={inputErrors.phone} type="text" helperText={inputErrors.destination} placeholder={text("phone")} label={text("client_phone")} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 2 ? "" : "none" }}>
                            <TextField variant="outlined" name="client" fullWidth error={inputErrors.client} type="text" helperText={inputErrors.destination} placeholder={text("name")} label={text("client_name")} />
                        </Grid> */}
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 2 ? "" : "none" }}>
                            <Autocomplete
                                disablePortal
                                options={country}
                                defaultValue={"India"}
                                renderInput={(params) => <TextField {...params} variant="outlined" name="country" fullWidth error={inputErrors.country} type="text" helperText={inputErrors.country} placeholder={text("consignment_number")} label={text("country")} />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }} sx={{ display: activeTab === 2 ? "" : "none" }}>
                            <TextField variant="outlined" name="address" fullWidth error={inputErrors.address} type="text" multiline rows={3} helperText={inputErrors.address} placeholder={text("address")} label={text("address")} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 3 ? "" : "none" }}>
                            <TextField variant="outlined" name="amount" defaultValue={0} fullWidth autoFocus error={inputErrors.amount} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.amount} placeholder=" ₹" label={text("booking_amount")} onKeyUp={handleAmountChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 3 ? "" : "none" }}>
                            <TextField variant="outlined" name="other" defaultValue={0} fullWidth error={inputErrors.other} type="number" slotProps={{ htmlInput: { step: 0.01, min: -100000, max: 100000 } }} helperText={inputErrors.other} placeholder=" ₹" label={text("other_charges_discount")} onKeyUp={handleOtherChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 3 ? "" : "none" }}>
                            <TextField variant="outlined" name="total" defaultValue={0} fullWidth error={inputErrors.total} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.total} placeholder=" ₹" label={text("total")} onBlur={handleTotalChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 3 && isGst && isFuel ? "" : "none" }}>
                            <TextField variant="outlined" name="subtotal" defaultValue={0} fullWidth error={inputErrors.subtotal} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.subtotal} placeholder=" ₹" label={text("taxable_total")} onBlur={handleSubTotalChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: isGst && isFuel ? 8 : 12 }} sx={{ display: activeTab === 3 ? "" : "none" }}>
                            <Button style={{ textTransform: "none" }} onClick={(e) => { setIsMisc(!isMisc); }}>
                                {isMisc ? <ExpandMore /> : <ExpandLess />}{text("pickup_packaging_or_insurance")}
                            </Button>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 3 && isMisc ? "" : "none" }}>
                            <TextField variant="outlined" name="pickup" defaultValue={0} fullWidth error={inputErrors.pickup} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.pickup} placeholder=" ₹" label={text("pickup_charge")} onKeyUp={handlePickupChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 3 && isMisc ? "" : "none" }}>
                            <TextField variant="outlined" name="packaging" defaultValue={0} fullWidth error={inputErrors.packaging} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.packaging} placeholder=" ₹" label={text("packaging_charge")} onKeyUp={handlePackagingChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }} sx={{ display: activeTab === 3 && isMisc ? "" : "none" }}>
                            <TextField variant="outlined" name="insurance" defaultValue={0} fullWidth error={inputErrors.insurance} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.insurance} placeholder={text("insurance_with_gst")} label={text("insurance")} onKeyUp={handleInsuranceChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }} sx={{ display: activeTab === 3 ? "" : "none" }}>
                            <Divider />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: activeTab === 3 ? "" : "none" }}>
                            <FormControlLabel control={<Switch name="is_fuel" />} label={text("fuel_surcharge")} onChange={handleIsFuelChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: activeTab === 3 ? "" : "none" }}>
                            <FormControlLabel control={<Switch name="is_gst" label="gst" />} label={text("gst_on_price")} onChange={handleIsGstChange} />
                        </Grid>
                        <Grid size={{ xs: 6, sm: 3 }} sx={{ display: activeTab === 3 && (isGst || isFuel) ? "" : "none" }}>
                            <TextField variant="outlined" name="fuel_rate" disabled={!isFuel} defaultValue={35} fullWidth error={inputErrors.fuel_rate} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 50 } }} helperText={inputErrors.fuel_rate} placeholder={text("percentage")} label={text("fuel_surcharge_rate")} onKeyUp={handleFuelrateChange} />
                        </Grid>
                        <Grid size={{ xs: 6, sm: 3 }} sx={{ display: activeTab === 3 && (isGst || isFuel) ? "" : "none" }}>
                            <TextField variant="outlined" name="fuel" defaultValue={0} fullWidth error={inputErrors.fuel} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.fuel} placeholder={text("fuel_35")} label={text("fuel")} onKeyUp={handleFuelChange} />
                        </Grid>
                        <Grid size={{ xs: 6, sm: 3 }} sx={{ display: activeTab === 3 && (isGst || isFuel) ? "" : "none" }}>
                            <TextField variant="outlined" name="gst_rate" disabled={!isGst} defaultValue={18} fullWidth error={inputErrors.gst_rate} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 38 } }} helperText={inputErrors.gst_rate} placeholder={text("percentage")} label={text("gst_rate")} onKeyUp={handleGstRateChange} />
                        </Grid>
                        <Grid size={{ xs: 6, sm: 3 }} sx={{ display: activeTab === 3 && (isGst || isFuel) ? "" : "none" }}>
                            <TextField variant="outlined" name="gst" defaultValue={0} fullWidth error={inputErrors.gst} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.gst} placeholder=" ₹" label={text("gst_amount_packaging_pickup_other")} onKeyUp={handleGSTChange} />
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6 }}>
                            <Button type="button" variant="contained" fullWidth onClick={backPage} disabled={activeTab === 1}>{text("back")}</Button>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6 }}>
                            <Button type="button" variant="contained" fullWidth disabled={activeTab === 3} onClick={nextPage} >{text("next")}</Button>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Button type="submit" variant="contained" fullWidth disabled={activeTab !== 3} onClick={validateInputs} color="success">{text("save")}</Button>
                        </Grid>
                    </Grid>
                    <TableContainer component={Paper} style={{ display: activeTab === 3 ? "" : "none" }}>
                        <Table size="small" aria-label={text("booking_breakout")}>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{text("consignment_booking")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.amount}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{text("pickup_charge")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.pickup}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{text("packaging_charge")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.packaging}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{Math.abs(billBreakout.other) <= 10 ? text("adjustment") : billBreakout.other >= 10 ? text("other_charge") : text("discount_")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.other}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{text("insurance")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.insurance}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{text("fuel_charge")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.fuel}</TableCell>
                                </TableRow>
                                <TableRow style={{ background: blue[50] }}>
                                    <TableCell>{text("taxable_value")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.is_gst ? billBreakout.subtotal : ((billBreakout.subtotal * 100 / 118).toFixed(2))}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{text("sgst_cgst")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.is_gst ? billBreakout.gst : (billBreakout.subtotal - (billBreakout.subtotal * 100 / 118)).toFixed(2)}</TableCell>
                                </TableRow>
                                <TableRow style={{ background: blue[100] }}>
                                    <TableCell>{text("payable_amount")}</TableCell>
                                    <TableCell align="right">₹ {billBreakout.total}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            <Chip avatar={<Avatar>D</Avatar>} label={text("desk_booking")} fullWidth />
        </MenuFrame>
    )
}


export default DeskBooking;
